import { Suspense } from 'react';
import { type OpenApiSchemaAlert } from '#shared/api/schema';
import { DashboardAlertsWindow } from './DashboardAlertsWindow';
import { DashboardAlertsWindowStub } from './DashboardAlertsWindowStub';

type DashboardAlertsWindowSuspenseProps = {
    alerts?: readonly OpenApiSchemaAlert[];
    isEmpty: boolean;
    onAction: VoidFunction;
    onClose: VoidFunction;
};

export const DashboardAlertsWindowSuspense = ({
    alerts,
    isEmpty,
    onAction,
    onClose,
}: DashboardAlertsWindowSuspenseProps) => (
    <Suspense fallback={<DashboardAlertsWindowStub />}>
        <DashboardAlertsWindow alerts={alerts} isEmpty={isEmpty} onAction={onAction} onClose={onClose} />
    </Suspense>
);
